import { useEffect, useState, useMemo, useRef } from 'react';
import styles from './myAccount.module.scss';
import { Skeleton, TextField, MenuItem } from '@mui/material';
import { MyAccountProps } from '../../../interfaces/components';
import { images } from '../../../constants/images';
import { civilOptions, genderOptions, residence, ACCOUNT_TYPES } from '../../../constants/profile';
import { optionsContractType, optionsIngressType } from '../../../constants/documentation';
import { optionsRent } from '../../../constants/Buy';
import countries from '../../../constants/countries.json'
import { capitalize, formatRut, validateRut } from '../../../helpers/app';
import { useToast } from "../../../helpers/hooks";
import TextFieldShared from "../../../components/TextField/TextField";
import SelectShared from "../../../components/Select/Select";
import ButtonShared from "../../../components/Button/Button";
import DatePickerShared from '../../../components/DatePicker/DatePicker';
import Modal from '../../../components/Modal/Modal';
import Compressor from 'compressorjs';
import PhoneInput from '../../../components/PhoneInput/PhoneInput';
import ModalValidationDocuments from '../../../components/ModalValidationDocuments/ModalValidationDocuments';
import { googleLogout } from '@react-oauth/google';
import ModalValidationProfile from '../../../components/ModalValidationProfile';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import ProfileLeftCard, { AccountSubTab, ProgressRing } from './ProfileLeftCard';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import TransgenderOutlinedIcon from '@mui/icons-material/TransgenderOutlined';
import FamilyRestroomOutlinedIcon from '@mui/icons-material/FamilyRestroomOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const MyAccount = ({
    user,
    token,
    getRegions,
    regions,
    getCities,
    cities,
    getCommunes,
    communes,
    patchResidence,
    fetchingPatchResidence,
    editUserReducer,
    editUserRequest,
    cleanProfileFetching,
    postImage,
    postUserImage,
    cleanPostImage,
    deleteUser,
    deleteFetching,
    logoutUser,
    reSendValidationFetching,
    reSendValidation,
    cleanReSendValidation,
    getIsValidDocuments,
    valid,
    cleanIsValidDocuments,
    validation,
    cleanExternalUser,
    banks,
    fetchingBanks,
    getBanks
}: any) => {
    const toast = useToast();
    const location = useLocation();
    const navigate = useNavigate();
    const mobileInputRef = useRef<HTMLInputElement>(null);
    const { modalTitle } = location?.state || {};
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingDeleteButton, setLoadingDeleteButton] = useState<boolean>(false);
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const [imageProfile, setImageProfile] = useState<string>("");
    const [newImageProfile, setNewImageProfile] = useState<any>({ path: "", file: "" });
    const [modalValidation, setModalValidation] = useState<any>({ open: false, type: "" });
    const [modalValidationProfile, setModalValidationProfile] = useState<any>({ open: false, type: "" });
    const [openEditModal, setOpenEditModal] = useState<boolean>(false);
    const [isEditingPersonal, setIsEditingPersonal] = useState<boolean>(false);
    const [isEditingCredit, setIsEditingCredit] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<AccountSubTab>(() => {
        const p = window.location.pathname;
        if (p.includes('/documentacion')) return 'documentacion';
        if (p.includes('/ajustes')) return 'ajustes';
        return 'info_personal';
    });

    const [name, setName] = useState<any>({ value: "", error: "" });
    const [lastName, setLastName] = useState<any>({ value: "", error: "" });
    const [email, setEmail] = useState<any>({ value: "", error: "" });
    const [street, setStreet] = useState<any>({ value: "", error: "" });
    const [streetNumber, setStreetNumber] = useState<any>({ value: "", error: "" });
    const [rut, setRut] = useState<any>({ value: "", error: "" });
    const [birthday, setBirthday] = useState<any>({ value: "", error: "" });
    const [phoneValue, setPhoneValue] = useState<any>({ code: "", number: "", error: "" });
    const [civilSelected, setCivilSelected] = useState<any>({ value: "", error: "" });
    const [genderSelected, setGenderSelected] = useState<any>({ value: "", error: "" });
    const [countrySelected, setCountrySelected] = useState<any>({ value: "", error: "" });
    const [newResidence, setNewResidence] = useState<boolean>(false);
    const [regionSelected, setRegionSelected] = useState<any>({ value: "", error: "" });
    const [citySelected, setCitySelected] = useState<any>({ value: "", error: "" });
    const [communeSelected, setCommuneSelected] = useState<any>({ value: "", error: "" });

    const [liquidRent, setLiquidRent] = useState<string>("");
    const [contractType, setContractType] = useState<string>("");
    const [ingressType, setIngressType] = useState<string>("");
    const [rentType, setRentType] = useState<string>("");
    const [antiquity, setAntiquity] = useState<number>(0);
    const [bankName, setBankName] = useState<any>({ value: "", error: "" });
    const [creditAccountType, setCreditAccountType] = useState<any>({ value: "", error: "" });
    const [creditAccountNumber, setCreditAccountNumber] = useState<any>({ value: 0, error: "" });

    const completionPercent = useMemo(() => {
        const docs = valid?.data?.completed || {};
        const fields = [
            // Info personal
            !!(user?.name && user?.last_name),
            !!(user?.phone?.number),
            !!(user?.legal_id),
            !!(user?.country),
            !!(user?.date_of_birth),
            !!(user?.gender),
            !!(user?.civil_status),
            !!(user?.address),
            // Info crediticia
            !!(user?.labor_data?.liquid_income),
            !!(user?.labor_data?.type_income),
            !!(user?.bank_data?.bank),
            !!(user?.bank_data?.account_number),
            // Documentación — cada tipo por separado
            !!docs.identity_card,
            !!docs.labor_data,
            !!docs.bank_data,
            !!docs.references,
        ];
        const filled = fields.filter(Boolean).length;
        return Math.round((filled / fields.length) * 100);
    }, [user, valid]);

    const isIncompleteProfile = useMemo(() => {
        const missingFields = [];
        if (!user?.residence?.region_id || !user?.residence?.region_name) missingFields.push({ field: 'region', error: true });
        if (!user?.address) missingFields.push({ field: 'address', error: true });
        if (!user?.residence?.city_id || !user?.residence?.city_name) missingFields.push({ field: 'city', error: true });
        if (!user?.residence?.commune_id || !user?.residence?.commune_name) missingFields.push({ field: 'commune', error: true });
        if (!user?.civil_status) missingFields.push({ field: 'civil_status', error: true });
        if (!user?.gender) missingFields.push({ field: 'gender', error: true });
        return { isIncomplete: missingFields.length > 0, missingFields };
    }, [user]);

    useEffect(() => {
        if (isIncompleteProfile.isIncomplete && modalTitle) {
            setModalValidationProfile({ open: true, type: "locationFault" });
        }
    }, [isIncompleteProfile, modalTitle]);

    useEffect(() => {
        if (location.pathname.includes('/documentacion')) setActiveTab('documentacion');
        else if (location.pathname.includes('/ajustes')) setActiveTab('ajustes');
        else setActiveTab((location.state as any)?.activeTab ?? 'info_personal');
    }, [location.pathname]);

    const handleTabChange = (tab: AccountSubTab) => {
        if (tab === 'documentacion') {
            navigate('/perfil/cuenta/documentacion');
            return;
        }
        if (tab === 'ajustes') {
            navigate('/perfil/cuenta/ajustes');
            return;
        }
        setActiveTab(tab);
        navigate('/perfil/cuenta', { state: { activeTab: tab } });
    };

    const handleClickReSendValidation = () => { reSendValidation(); };

    const handleChangeImage = (event: any) => {
        const file = event.target.files[0];
        new Compressor(file, {
            success(result) {
                const localPath = URL.createObjectURL(result);
                setNewImageProfile({ path: localPath, file: result });
                setLoading(true);
                const formData = new FormData();
                formData.append("file", result, (result as File).name);
                postUserImage(formData, token);
            },
            error() {
                toast("Ha ocurrido un error al procesar la imagen");
            }
        });
    };

    const handleChangeRut = (value: any) => {
        const formatValue = formatRut(value);
        if (!validateRut(formatValue)) return setRut({ value: formatValue, error: "Ingresa un rut válido" });
        setRut({ ...rut, value: formatValue });
    };

    const handleChangeBirthday = (value: any) => {
        if (value && value.format) {
            setBirthday({ ...birthday, value: value.format("YYYY-MM-DD") });
        } else {
            setBirthday({ ...birthday, value });
        }
    };
    const handleChangePhone = (value: any, type: string) => {
        if (type === "code") setPhoneValue({ ...phoneValue, code: value });
        else setPhoneValue({ ...phoneValue, number: value });
    };
    const handleChangeCivil = (name: string) => { setCivilSelected({ ...civilSelected, value: name }); };
    const handleChangeGender = (name: string) => { setGenderSelected({ ...genderSelected, value: name }); };
    const handleChangeCountry = (name: string) => { setCountrySelected({ ...countrySelected, value: name }); };

    const handleChangeRegion = (id: string) => {
        const region = regions.data.find(({ region_id }: any) => region_id === id);
        setRegionSelected({ ...regionSelected, value: { id: region?.region_id, name: region?.name } });
        getCities(id);
        setNewResidence(true);
        setCitySelected({ ...citySelected, value: "" });
        setCommuneSelected({ ...communeSelected, value: "" });
    };
    const handleChangeCity = (id: string) => {
        const city = cities.data.find(({ city_id }: any) => city_id === id);
        setCitySelected({ ...citySelected, value: { id: city?.city_id, name: city?.name } });
        getCommunes(id);
        setNewResidence(true);
        setCommuneSelected({ ...communeSelected, value: "" });
    };
    const handleChangeCommune = (id: string) => {
        const commune = communes.data.find(({ commune_id }: any) => commune_id === id);
        setCommuneSelected({ ...communeSelected, value: { id: commune?.commune_id, name: commune?.name } });
        setNewResidence(true);
    };

    const updateDataUser = () => {
        const selectedOption = civilOptions.find(option => option.name === civilSelected?.value);
        const selectedOptionGender = genderOptions.find(option => option.name === genderSelected?.value);
        let picture = user?.picture;
        if (postImage?.data.length !== 0) picture = postImage?.data?.path;
        const { nationality, ...userRest } = user as any;
        editUserRequest({
            ...userRest,
            name: name?.value,
            last_name: lastName?.value,
            email: email?.value,
            legal_id: formatRut(rut?.value),
            phone: { code: phoneValue?.code, number: phoneValue?.number },
            date_of_birth: birthday?.value,
            picture,
            country: countrySelected?.value,
            gender: selectedOptionGender?.value,
            civil_status: selectedOption?.value,
            residence: user?.residence,
            references: user?.references || [],
            address: `${street?.value} ${streetNumber?.value}`
        });
    };

    const handleSave = () => {
        if (!name?.value) return setName({ ...name, error: "Debes ingresar un nombre" });
        if (!lastName?.value) return setLastName({ ...lastName, error: "Debes ingresar un apellido" });
        if (!email?.value) return setEmail({ ...email, error: "Debes ingresar un email" });
        if (!birthday?.value) return setBirthday({ ...birthday, error: "Debes ingresar una fecha de nacimiento" });
        if (!rut?.value) return setRut({ ...rut, error: "Debes ingresar un rut" });
        if (!phoneValue?.code) return setPhoneValue({ ...phoneValue, error: "Debes ingresar un pais" });
        if (!phoneValue?.number) return setPhoneValue({ ...phoneValue, error: "Debes ingresar un telefono" });
        if (!civilSelected?.value) return setCivilSelected({ ...civilSelected, error: "Debes seleccionar un estado civil" });
        if (!genderSelected?.value) return setGenderSelected({ ...genderSelected, error: "Debes seleccionar un genero" });
        if (!regionSelected?.value) return setRegionSelected({ ...regionSelected, error: "Debes seleccionar una región" });
        if (!street?.value) return setStreet({ ...street, error: "Debes ingresar una calle" });
        if (!streetNumber?.value) return setStreetNumber({ ...streetNumber, error: "Debes ingresar un numero" });
        if (regionSelected?.value) {
            if (!citySelected?.value) {
                setCitySelected({ ...citySelected, error: "Debes seleccionar una ciudad" });
                if (!communeSelected?.value) return setCommuneSelected({ ...communeSelected, error: "Debes seleccionar una comuna" });
            }
            if (!communeSelected?.value) return setCommuneSelected({ ...communeSelected, error: "Debes seleccionar una comuna" });
        }
        setLoading(true);
        if (!newImageProfile?.path && user?.residence?.region_id === regionSelected?.value?.id && user?.residence?.city_id === citySelected?.value?.id && user?.residence?.commune_id === communeSelected?.value?.id) {
            updateDataUser();
        }
        if (newImageProfile?.path) {
            const formData = new FormData();
            formData.append("file", newImageProfile?.file, newImageProfile?.file?.name);
            postUserImage(formData, token);
        }
        if (newResidence) {
            residence.region_id = regionSelected?.value?.id;
            residence.region_name = regionSelected?.value?.name;
            residence.city_id = citySelected?.value?.id;
            residence.city_name = citySelected?.value?.name;
            residence.commune_id = communeSelected?.value?.id;
            residence.commune_name = communeSelected?.value?.name;
            residence.references = [];
            patchResidence(residence);
        }
    };

    const handleDelete = () => {
        if (!(user?.profile?.code === "seller")) setOpenDeleteModal(true);
    };

    const regionsNormalized: any = useMemo(() => regions.data?.map((r: any) => ({ id: r.region_id, name: r.name })), [regions.data]);
    const citiesNormalized: any = useMemo(() => cities.data?.map((c: any) => ({ id: c?.city_id, name: c?.name })), [cities.data]);
    const communesNormalized: any = useMemo(() => communes.data?.map((c: any) => ({ id: c?.commune_id, name: c?.name, cityId: c?.city_id })), [communes.data]);
    const countriesNormalized: any = useMemo(() => countries?.map((c: any) => ({ id: c?.dial_code, name: c?.name })), [countries]);

    useEffect(() => {
        if (valid?.fetching === "failure") { toast("Ha ocurrido un error al calcular la validación de su documentación"); cleanIsValidDocuments(); }
        if (valid?.fetching === "success") {
            cleanIsValidDocuments();
            const someNotCompleted = valid?.data && Object.values(valid?.data?.completed).some((item: any) => !item);
            if (validation?.waiting && someNotCompleted && valid?.data?.completed?.residence) { setModalValidation({ open: true, type: "documentsFault" }); return; }
            if (validation?.waiting && !someNotCompleted) setModalValidation({ open: true, type: "" });
        }
    }, [valid?.fetching]);

    useEffect(() => {
        if (reSendValidationFetching === "failure") { toast("Ha ocurrido un error al enviar el email de verificación"); cleanReSendValidation(); }
        if (reSendValidationFetching === "success") { toast("Se te ha enviado un email de verificación"); cleanReSendValidation(); }
    }, [reSendValidationFetching]);

    useEffect(() => {
        if (deleteFetching === "loading") setLoadingDeleteButton(true);
        if (deleteFetching === "failure") { setLoadingDeleteButton(false); toast("Ha ocurrido un error al eliminar el usuario"); }
        if (deleteFetching === "success") {
            toast("Usuario eliminado correctamente");
            setLoadingDeleteButton(false);
            setOpenDeleteModal(false);
            cleanExternalUser();
            googleLogout();
            logoutUser();
        }
    }, [deleteFetching]);

    useEffect(() => {
        if (postImage?.fetching === "failure") { toast("Ha ocurrido un error al actualizar la foto de perfil"); setLoading(false); cleanPostImage(); }
        if (postImage?.fetching === "success") {
            setImageProfile(newImageProfile.path);
            setNewImageProfile({ path: "", file: "" });
            if (!newResidence) { updateDataUser(); cleanPostImage(); }
            else { cleanPostImage(); }
        }
    }, [postImage?.fetching]);

    useEffect(() => {
        if (fetchingPatchResidence === "failure") { toast("Ha ocurrido un error al actualizar la residencia"); setLoading(false); cleanProfileFetching(); }
        if (fetchingPatchResidence === "success" && newImageProfile?.path.length !== 0) setNewResidence(false);
        if (fetchingPatchResidence === "success" && newImageProfile?.path.length === 0) updateDataUser();
    }, [fetchingPatchResidence]);

    useEffect(() => {
        if (postImage?.fetching === "success" && fetchingPatchResidence === "success" && newImageProfile?.path.length === 0 && !newResidence) updateDataUser();
    }, [newResidence, newImageProfile]);

    useEffect(() => {
        if (editUserReducer === "loading") setLoading(true);
        if (editUserReducer === "success") { setLoading(false); toast("Cambios realizados correctamente"); getIsValidDocuments(); cleanProfileFetching(); setOpenEditModal(false); setIsEditingPersonal(false); setIsEditingCredit(false); }
        if (editUserReducer === "failure") { setLoading(false); toast("Ha ocurrido un error"); cleanProfileFetching(); }
    }, [editUserReducer]);

    useEffect(() => {
        setName({ ...name, value: user?.name ?? "" });
        setLastName({ ...lastName, value: user?.last_name ?? "" });
        setEmail({ ...email, value: user?.email ?? "" });
        setRut({ ...rut, value: user?.legal_id ? formatRut(user?.legal_id) : "" });
        setBirthday({ ...birthday, value: user?.date_of_birth ?? "" });
        setPhoneValue({ code: user?.phone?.code, number: user?.phone?.number, error: "" });
        const selectedOption = civilOptions.find(option => option.value === user?.civil_status);
        setCivilSelected({ ...civilSelected, value: selectedOption ? selectedOption.name : "" });
        setGenderSelected({ ...genderSelected, value: capitalize(user?.gender) });
        setCountrySelected({ ...countrySelected, value: user?.country ?? "" });
        setRegionSelected({ ...regionSelected, value: user?.residence?.region_id ? { id: user?.residence?.region_id, name: user?.residence?.region_name } : "" });
        setCitySelected({ ...citySelected, value: user?.residence?.city_id ? { id: user?.residence?.city_id, name: user?.residence?.city_name } : "" });
        setCommuneSelected({ ...communeSelected, value: user?.residence?.commune_id ? { id: user?.residence?.commune_id, name: user?.residence?.commune_name } : "" });
        setStreet({ ...street, value: user?.address ? user?.address.split(" ").slice(0, -1).join(" ") : "" });
        setStreetNumber({ ...street, value: user?.address ? user?.address.split(" ").pop() : "" });
        if (user?.labor_data) {
            setLiquidRent(user.labor_data.liquid_income ? user.labor_data.liquid_income.toString() : "0");
            setContractType(user.labor_data.type_contract ?? "");
            setIngressType(user.labor_data.type_income ?? "");
            setAntiquity(user.labor_data.seniority ?? 0);
            setRentType(user.labor_data.type_rent ?? "");
        }
        if (user?.bank_data) {
            setBankName({ value: user.bank_data.bank ?? "", error: "" });
            const acctType = ACCOUNT_TYPES.find((t: any) => t.id === user.bank_data?.account_type);
            setCreditAccountType({ value: acctType?.value ?? "", error: "" });
            setCreditAccountNumber({ value: user.bank_data.account_number ?? 0, error: "" });
        }
    }, [user]);

    useEffect(() => {
        getIsValidDocuments();
        getRegions();
        getBanks();
        if (user?.picture) setImageProfile(user?.picture);
        if (user?.residence) { getCities(user?.residence.region_id); getCommunes(user?.residence.city_id); }
    }, []);

    const InfoRow = ({
        icon,
        value,
        label,
        completed,
        onClick,
    }: {
        icon: React.ReactNode;
        value?: any;
        label: string;
        completed: boolean;
        onClick?: () => void;
    }) => {
        const inner = (
            <>
                <div className={styles.infoRowLeft}>
                    <span className={styles.infoRowIcon}>{icon}</span>
                    <div className={styles.infoRowText}>
                        {value ? (
                            <>
                                <span className={styles.infoRowLabel}>{label}</span>
                                <span className={styles.infoRowValue}>{value}</span>
                            </>
                        ) : (
                            <span className={styles.infoRowEmpty}>{label}</span>
                        )}
                    </div>
                </div>
                <div className={styles.infoRowRight}>
                    {completed
                        ? <CheckCircleIcon className={styles.statusCheck} />
                        : <ErrorIcon className={styles.statusWarning} />
                    }
                    {onClick && <ChevronRightIcon className={styles.chevron} />}
                </div>
            </>
        );
        if (onClick) return <button type="button" className={styles.infoRow} onClick={onClick}>{inner}</button>;
        return <div className={styles.infoRowStatic}>{inner}</div>;
    };

    const openEdit = () => setOpenEditModal(true);

    const resetPersonalFields = () => {
        setName({ value: user?.name ?? "", error: "" });
        setLastName({ value: user?.last_name ?? "", error: "" });
        setRut({ value: user?.legal_id ? formatRut(user?.legal_id) : "", error: "" });
        setBirthday({ value: user?.date_of_birth ?? "", error: "" });
        setPhoneValue({ code: user?.phone?.code, number: user?.phone?.number, error: "" });
        setCivilSelected({ value: civilOptions.find((o: any) => o.value === user?.civil_status)?.name ?? "", error: "" });
        setGenderSelected({ value: capitalize(user?.gender) ?? "", error: "" });
        setCountrySelected({ value: user?.country ?? "", error: "" });
        setRegionSelected({ value: user?.residence?.region_id ? { id: user.residence.region_id, name: user.residence.region_name } : "", error: "" });
        setCitySelected({ value: user?.residence?.city_id ? { id: user.residence.city_id, name: user.residence.city_name } : "", error: "" });
        setCommuneSelected({ value: user?.residence?.commune_id ? { id: user.residence.commune_id, name: user.residence.commune_name } : "", error: "" });
        setStreet({ value: user?.address ? user.address.split(" ").slice(0, -1).join(" ") : "", error: "" });
        setStreetNumber({ value: user?.address ? user.address.split(" ").pop() : "", error: "" });
    };

    const handleCancelEdit = () => { resetPersonalFields(); setIsEditingPersonal(false); };

    const resetCreditFields = () => {
        setLiquidRent(user?.labor_data?.liquid_income?.toString() ?? "0");
        setContractType(user?.labor_data?.type_contract ?? "");
        setIngressType(user?.labor_data?.type_income ?? "");
        setAntiquity(user?.labor_data?.seniority ?? 0);
        setRentType(user?.labor_data?.type_rent ?? "");
        setBankName({ value: user?.bank_data?.bank ?? "", error: "" });
        const acctType = ACCOUNT_TYPES.find((t: any) => t.id === user?.bank_data?.account_type);
        setCreditAccountType({ value: acctType?.value ?? "", error: "" });
        setCreditAccountNumber({ value: user?.bank_data?.account_number ?? 0, error: "" });
    };

    const handleCancelCreditEdit = () => { resetCreditFields(); setIsEditingCredit(false); };

    const handleSaveCredit = () => {
        if (!liquidRent || liquidRent === "0") return toast("Debes ingresar una renta líquida");
        if (!ingressType) return toast("Debes seleccionar un tipo de ingreso");
        if (!contractType) return toast("Debes seleccionar un tipo de contrato");
        if (!antiquity) return toast("Debes ingresar la antigüedad laboral");
        if (!rentType) return toast("Debes seleccionar un tipo de renta");
        if (!bankName?.value) return setBankName({ ...bankName, error: "Debes seleccionar un banco" });
        if (!creditAccountType?.value) return setCreditAccountType({ ...creditAccountType, error: "Debes seleccionar un tipo de cuenta" });
        if (!creditAccountNumber?.value) return setCreditAccountNumber({ ...creditAccountNumber, error: "Debes ingresar un número de cuenta" });
        setLoading(true);
        const { nationality, ...userRest } = user as any;
        editUserRequest({
            ...userRest,
            labor_data: {
                liquid_income: Number(String(liquidRent).replaceAll(".", "")),
                type_contract: contractType,
                type_income: ingressType,
                seniority: Number(antiquity),
                type_rent: rentType,
            },
            bank_data: {
                bank: bankName?.value,
                account_type: creditAccountType?.value,
                account_number: creditAccountNumber?.value,
            },
            references: user?.references || [],
        });
    };

    const phoneDisplay = user?.phone?.code && user?.phone?.number
        ? `${user.phone.code} ${user.phone.number}`
        : undefined;

    const addressDisplay = user?.address
        ? [user.address, user?.residence?.commune_name, user?.residence?.city_name].filter(Boolean).join(', ')
        : undefined;

    return (
        <>
            <ModalValidationDocuments open={modalValidation?.open} setOpen={setModalValidation} type={modalValidation?.type} />
            <ModalValidationProfile modalDescription={modalTitle} user={user} open={modalValidationProfile?.open} setOpen={setModalValidationProfile} type={modalValidationProfile?.type} />

            <div className={`${styles.accountPage} ${(activeTab === 'documentacion' || activeTab === 'ajustes') ? styles.accountPageWide : ''}`}>
                <div className={styles.pageHeader}>
                    {regions?.fetching === "loading"
                        ? <Skeleton variant="text" width={140} height={32} />
                        : <h2 className={styles.greeting}>¡Hola {user?.name}!</h2>
                    }
                    {/* <button type="button" className={styles.smartLoadBtn}>
                        <AutoAwesomeIcon fontSize="small" />
                        <span>Carga inteligente</span>
                    </button> */}
                </div>

                {/* Mobile header — only visible on mobile */}
                <div className={styles.mobileHeader}>
                    <div className={styles.mobileAvatarWrapper}>
                        <ProgressRing percent={completionPercent} size={80} />
                        <div className={styles.mobileAvatarCircle}>
                            <img src={newImageProfile?.path || imageProfile || images.profile} alt="Foto de perfil" />
                            {postImage?.fetching === "loading" && (
                                <div className={styles.mobileAvatarOverlay}><span className={styles.mobileSpinner} /></div>
                            )}
                        </div>
                        <button
                            type="button"
                            className={styles.mobileUploadBtn}
                            onClick={() => mobileInputRef.current?.click()}
                            disabled={postImage?.fetching === "loading"}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M5 20h14v-2H5v2zm0-10h4v6h6v-6h4l-7-7-7 7z"/></svg>
                        </button>
                        <input ref={mobileInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleChangeImage} />
                    </div>
                    <div className={styles.mobileUserInfo}>
                        <p className={styles.mobileName}>{user?.name} {user?.last_name}</p>
                        <div className={styles.mobileEmailRow}>
                            {!user?.email_verification?.verified && <ErrorIcon className={styles.mobileEmailWarning} fontSize="small" />}
                            <span className={styles.mobileEmail}>{user?.email}</span>
                        </div>
                    </div>
                </div>

                {/* Mobile tabs — only visible on mobile */}
                <div className={styles.mobileTabs}>
                    <button
                        type="button"
                        className={`${styles.mobileTab} ${activeTab === 'info_personal' ? styles.mobileTabActive : ''}`}
                        onClick={() => handleTabChange('info_personal')}
                    >
                        Datos personales
                    </button>
                    <button
                        type="button"
                        className={`${styles.mobileTab} ${activeTab === 'info_crediticia' ? styles.mobileTabActive : ''}`}
                        onClick={() => handleTabChange('info_crediticia')}
                    >
                        Datos crediticios
                    </button>
                    <button
                        type="button"
                        className={`${styles.mobileTab} ${activeTab === 'documentacion' ? styles.mobileTabActive : ''}`}
                        onClick={() => handleTabChange('documentacion')}
                    >
                        Documentación
                    </button>
                    <button
                        type="button"
                        className={`${styles.mobileTab} ${activeTab === 'ajustes' ? styles.mobileTabActive : ''}`}
                        onClick={() => handleTabChange('ajustes')}
                    >
                        Ajustes
                    </button>
                </div>

                <div className={styles.twoColumns}>
                    <ProfileLeftCard
                        user={user}
                        imageProfile={imageProfile}
                        newImageProfile={newImageProfile}
                        onChangeImage={handleChangeImage}
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                        completionPercent={completionPercent}
                        imageLoading={postImage?.fetching === "loading"}
                    />

                    <div className={`${styles.rightPanel} ${location.pathname.includes('identificacion') ? styles.rightPanelIdentity : ''}`}>
                        {(activeTab === 'documentacion' || activeTab === 'ajustes') ? (
                            <Outlet />
                        ) : activeTab === 'info_personal' ? (
                            <div className={styles.infoPanel}>
                                <div className={styles.infoPanelHeader}>
                                    <span className={styles.infoPanelTitle}>Info personal</span>
                                    {isEditingPersonal ? (
                                        <div className={styles.editFormActions}>
                                            <button type="button" className={styles.cancelBtn} onClick={handleCancelEdit}>Cancelar</button>
                                            <button type="button" className={styles.saveBtn} onClick={handleSave} disabled={loading}>
                                                {loading ? 'Guardando...' : 'Guardar cambios'}
                                            </button>
                                        </div>
                                    ) : (
                                        <button type="button" className={styles.editPersonalBtn} onClick={() => setIsEditingPersonal(true)}>
                                            Editar
                                        </button>
                                    )}
                                </div>

                                {isEditingPersonal ? (
                                    <div className={styles.editForm}>
                                        <div className={styles.editSection}>
                                            <div className={styles.editGrid2}>
                                                <TextField label="Nombre" variant="outlined" fullWidth value={name?.value || ''} onChange={(e) => setName({ ...name, value: e.target.value.replace(/[^a-záéíóúüñA-ZÁÉÍÓÚÜÑ\s]/g, '') })} error={!!name?.error} helperText={name?.error} />
                                                <TextField label="Apellido" variant="outlined" fullWidth value={lastName?.value || ''} onChange={(e) => setLastName({ ...lastName, value: e.target.value.replace(/[^a-záéíóúüñA-ZÁÉÍÓÚÜÑ\s]/g, '') })} error={!!lastName?.error} helperText={lastName?.error} />
                                                <TextField label="RUT" variant="outlined" fullWidth value={rut?.value || ''} onChange={(e) => handleChangeRut(e.target.value)} error={!!rut?.error} helperText={rut?.error} />
                                                <PhoneInput label="Teléfono" numberValue={phoneValue.number} codeValue={phoneValue.code} onChange={handleChangePhone} error={phoneValue?.error} className={styles.editPhoneOverride} />
                                                <DatePickerShared name="birthday" label="Fecha de nacimiento" value={birthday?.value} onChange={handleChangeBirthday} inputFormat="DD/MM/YYYY" inputVariant="outlined" loading={regions?.fetching === "loading"} error={birthday?.error} />
                                                <TextField label="Nacionalidad" variant="outlined" fullWidth select value={countrySelected?.value || ''} onChange={(e) => handleChangeCountry(e.target.value)} error={!!countrySelected?.error} helperText={countrySelected?.error}>
                                                    {countriesNormalized?.map((opt: any) => <MenuItem key={opt.id || opt.name} value={opt.name}>{opt.name}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Género" variant="outlined" fullWidth select value={genderSelected?.value || ''} onChange={(e) => handleChangeGender(e.target.value)} error={!!genderSelected?.error} helperText={genderSelected?.error}>
                                                    {genderOptions?.map((opt: any) => <MenuItem key={opt.name} value={opt.name}>{opt.name}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Estado Civil" variant="outlined" fullWidth select value={civilSelected?.value || ''} onChange={(e) => handleChangeCivil(e.target.value)} error={!!civilSelected?.error} helperText={civilSelected?.error}>
                                                    {civilOptions?.map((opt: any) => <MenuItem key={opt.name} value={opt.name}>{opt.name}</MenuItem>)}
                                                </TextField>
                                            </div>
                                            <div className={styles.editGrid3}>
                                                <TextField label="Región" variant="outlined" fullWidth select value={regionSelected?.value?.id || ''} onChange={(e) => handleChangeRegion(e.target.value)} disabled={regions?.fetching === "loading"} error={!!regionSelected?.error} helperText={regionSelected?.error}>
                                                    {regionsNormalized?.map((opt: any) => <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Ciudad" variant="outlined" fullWidth select value={citySelected?.value?.id || ''} onChange={(e) => handleChangeCity(e.target.value)} disabled={!citiesNormalized?.length} error={!!citySelected?.error} helperText={citySelected?.error}>
                                                    {citiesNormalized?.map((opt: any) => <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Comuna" variant="outlined" fullWidth select value={communeSelected?.value?.id || ''} onChange={(e) => handleChangeCommune(e.target.value)} disabled={!communesNormalized?.length} error={!!communeSelected?.error} helperText={communeSelected?.error}>
                                                    {communesNormalized?.map((opt: any) => <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>)}
                                                </TextField>
                                            </div>
                                            <div className={styles.editGrid2}>
                                                <TextField label="Calle" variant="outlined" fullWidth value={street?.value || ''} onChange={(e) => setStreet({ ...street, value: e.target.value })} error={!!street?.error} helperText={street?.error} />
                                                <TextField label="Número" variant="outlined" fullWidth value={streetNumber?.value || ''} onChange={(e) => setStreetNumber({ ...streetNumber, value: e.target.value.replace(/\D/g, '') })} error={!!streetNumber?.error} helperText={streetNumber?.error} />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <InfoRow icon={<BadgeOutlinedIcon fontSize="small" />} value={user?.name && user?.last_name ? `${user.name} ${user.last_name}` : undefined} label="Nombre/s y Apellido/s" completed={!!(user?.name && user?.last_name)} />
                                        <InfoRow icon={<PhoneOutlinedIcon fontSize="small" />} value={phoneDisplay} label="Teléfono donde recibes notificaciones" completed={!!(user?.phone?.number)} />
                                        <InfoRow icon={<BadgeOutlinedIcon fontSize="small" />} value={user?.legal_id ? formatRut(user.legal_id) : undefined} label="RUT" completed={!!(user?.legal_id)} />
                                        <InfoRow icon={<PublicOutlinedIcon fontSize="small" />} value={user?.country} label="Nacionalidad" completed={!!(user?.country)} />
                                        <InfoRow icon={<CakeOutlinedIcon fontSize="small" />} value={user?.date_of_birth ? user.date_of_birth.split("T")[0].split("-").reverse().join("/") : undefined} label="Fecha de nacimiento" completed={!!(user?.date_of_birth)} />
                                        <InfoRow icon={<TransgenderOutlinedIcon fontSize="small" />} value={user?.gender ? capitalize(user.gender) : undefined} label="Género" completed={!!(user?.gender)} />
                                        <InfoRow icon={<FamilyRestroomOutlinedIcon fontSize="small" />} value={user?.civil_status ? civilOptions.find((o: any) => o.value === user.civil_status)?.name : undefined} label="Estado Civil" completed={!!(user?.civil_status)} />
                                        <InfoRow icon={<LocationOnOutlinedIcon fontSize="small" />} value={addressDisplay} label="Domicilio" completed={!!(user?.address)} />
                                        {!user?.email_verification?.verified && (
                                            <p className={styles.validateEmail} onClick={handleClickReSendValidation}>
                                                Aún no validaste tu mail — reenviar verificación
                                            </p>
                                        )}
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className={styles.infoPanel}>
                                <div className={styles.infoPanelHeader}>
                                    <span className={styles.infoPanelTitle}>Info crediticia</span>
                                    {isEditingCredit ? (
                                        <div className={styles.editFormActions}>
                                            <button type="button" className={styles.cancelBtn} onClick={handleCancelCreditEdit}>Cancelar</button>
                                            <button type="button" className={styles.saveBtn} onClick={handleSaveCredit} disabled={loading}>
                                                {loading ? 'Guardando...' : 'Guardar cambios'}
                                            </button>
                                        </div>
                                    ) : (
                                        <button type="button" className={styles.editPersonalBtn} onClick={() => setIsEditingCredit(true)}>
                                            Editar
                                        </button>
                                    )}
                                </div>

                                {isEditingCredit ? (
                                    <div className={styles.editForm}>
                                        <div className={styles.editSection}>
                                            <div className={styles.editGrid2}>
                                                <TextField label="Renta Líquida" variant="outlined" fullWidth value={liquidRent || ''} onChange={(e) => setLiquidRent(e.target.value.replace(/\D/g, ''))} />
                                                <TextField label="Tipo de ingreso" variant="outlined" fullWidth select value={ingressType || ''} onChange={(e) => setIngressType(e.target.value)}>
                                                    {optionsIngressType?.map((opt: any) => <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Tipo de contrato" variant="outlined" fullWidth select value={contractType || ''} onChange={(e) => setContractType(e.target.value)}>
                                                    {optionsContractType?.map((opt: any) => <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Antigüedad laboral (meses)" variant="outlined" fullWidth value={antiquity || ''} onChange={(e) => setAntiquity(Number(e.target.value.replace(/\D/g, '')) || 0)} />
                                                <TextField label="Tipo de renta" variant="outlined" fullWidth select value={rentType || ''} onChange={(e) => setRentType(e.target.value)}>
                                                    {optionsRent?.map((opt: any) => <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Nombre del Banco" variant="outlined" fullWidth select value={bankName?.value || ''} onChange={(e) => setBankName({ ...bankName, value: e.target.value })} disabled={fetchingBanks === "loading"} error={!!bankName?.error} helperText={bankName?.error}>
                                                    {(banks || [])?.map((bank: any) => <MenuItem key={bank.name} value={bank.name}>{bank.name}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Tipo de cuenta" variant="outlined" fullWidth select value={creditAccountType?.value || ''} onChange={(e) => setCreditAccountType({ ...creditAccountType, value: e.target.value })} error={!!creditAccountType?.error} helperText={creditAccountType?.error}>
                                                    {ACCOUNT_TYPES?.map((opt: any) => <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>)}
                                                </TextField>
                                                <TextField label="Número de cuenta" variant="outlined" fullWidth value={creditAccountNumber?.value || ''} onChange={(e) => setCreditAccountNumber({ ...creditAccountNumber, value: e.target.value.replace(/\D/g, '') })} error={!!creditAccountNumber?.error} helperText={creditAccountNumber?.error} />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <InfoRow icon={<AttachMoneyIcon fontSize="small" />} value={user?.labor_data?.liquid_income ? `$${user.labor_data.liquid_income.toLocaleString('es-CL')}` : undefined} label="Renta Líquida" completed={!!(user?.labor_data?.liquid_income)} />
                                        <InfoRow icon={<WorkOutlineIcon fontSize="small" />} value={optionsIngressType.find((o: any) => o.value === user?.labor_data?.type_income)?.label} label="Tipo de ingreso" completed={!!(user?.labor_data?.type_income)} />
                                        <InfoRow icon={<DescriptionOutlinedIcon fontSize="small" />} value={optionsContractType.find((o: any) => o.value === user?.labor_data?.type_contract)?.label} label="Tipo de contrato" completed={!!(user?.labor_data?.type_contract)} />
                                        <InfoRow icon={<CalendarTodayOutlinedIcon fontSize="small" />} value={user?.labor_data?.seniority ? `${user.labor_data.seniority} meses` : undefined} label="Antigüedad laboral" completed={!!(user?.labor_data?.seniority)} />
                                        <InfoRow icon={<TrendingUpIcon fontSize="small" />} value={optionsRent.find((o: any) => o.value === user?.labor_data?.type_rent)?.label} label="Tipo de renta" completed={!!(user?.labor_data?.type_rent)} />
                                        <InfoRow icon={<AccountBalanceOutlinedIcon fontSize="small" />} value={user?.bank_data?.bank} label="Banco" completed={!!(user?.bank_data?.bank)} />
                                        <InfoRow icon={<PeopleOutlineIcon fontSize="small" />} value={ACCOUNT_TYPES.find((t: any) => t.id === user?.bank_data?.account_type)?.name} label="Tipo de cuenta" completed={!!(user?.bank_data?.account_type)} />
                                        <InfoRow icon={<DescriptionOutlinedIcon fontSize="small" />} value={user?.bank_data?.account_number} label="Número de cuenta" completed={!!(user?.bank_data?.account_number)} />
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Edit modal */}
            <Modal open={openEditModal} variant="white" className={styles.editModalContainer}>
                <div className={styles.editModalScroll}>
                    <div className={styles.infoSegment}>
                        <div className={styles.sectionTitle}>Datos personales</div>
                        <div className={styles.grid}>
                            <TextFieldShared label="Nombre" name="nameInput" value={name?.value} checker="onlyLetters" className={styles.half} onChange={(v: any) => setName({ ...name, value: v })} loading={regions?.fetching === "loading"} error={name?.error} />
                            <TextFieldShared label="Apellido" name="lastNameInput" checker="onlyLetters" value={lastName?.value} className={styles.half} onChange={(v: any) => setLastName({ ...lastName, value: v })} loading={regions?.fetching === "loading"} error={lastName?.error} />
                            <TextFieldShared label="RUT" name="rutInput" value={rut?.value} className={styles.half} onChange={handleChangeRut} loading={regions?.fetching === "loading"} error={rut?.error} />
                            <PhoneInput label="Telefono" numberValue={phoneValue.number} codeValue={phoneValue.code} onChange={handleChangePhone} error={phoneValue?.error} className={styles.half} />
                        </div>
                    </div>

                    {!(user?.profile?.code === "seller") && (
                        <div className={styles.infoSegment}>
                            <div className={styles.sectionTitle}>Información adicional</div>
                            <div className={styles.grid}>
                                <TextFieldShared label="Email" name="email" value={email?.value} disabled className={styles.half} loading={regions?.fetching === "loading"} />
                                <DatePickerShared name="birthday" label="Fecha de nacimiento" value={birthday?.value} onChange={handleChangeBirthday} inputFormat="DD/MM/YYYY" className={styles.half} loading={regions?.fetching === "loading"} error={birthday?.error} />
                                <SelectShared label="Estado civil" name="civilInput" value={civilSelected?.value} className={styles.half} onChange={handleChangeCivil} options={civilOptions} loading={regions?.fetching === "loading"} keyValue="name" error={civilSelected?.error} />
                                <SelectShared label="Genero" name="genderInput" value={genderSelected?.value} className={styles.half} onChange={handleChangeGender} options={genderOptions} loading={regions?.fetching === "loading"} keyValue="name" error={genderSelected?.error} />
                            </div>
                        </div>
                    )}

                    <div className={styles.infoSegment}>
                        <div className={styles.sectionTitle}>Ubicación</div>
                        <div className={styles.grid}>
                            <SelectShared label="Pais" name="country" value={countrySelected?.value} className={styles.half} onChange={handleChangeCountry} options={countriesNormalized} loading={regions?.fetching === "loading"} keyValue="name" error={countrySelected?.error} />
                            <SelectShared label="Región" name="region" value={regionSelected?.value && regionSelected?.value?.id} onChange={handleChangeRegion} options={regionsNormalized} loading={regions?.fetching === "loading"} error={regionSelected?.error} className={styles.half} />
                            <SelectShared label="Ciudad" name="city" value={citySelected?.value && citySelected?.value?.id} onChange={handleChangeCity} options={citiesNormalized} optionsEmptyMessage="Debes seleccionar una región" loading={regions?.fetching === "loading"} error={citySelected?.error} className={styles.half} />
                            <SelectShared label="Comuna" name="commune" value={communeSelected?.value && communeSelected?.value?.id} onChange={handleChangeCommune} options={communesNormalized} optionsEmptyMessage="Debes seleccionar una ciudad" loading={regions?.fetching === "loading"} error={communeSelected?.error} className={styles.half} />
                            <TextFieldShared label="Calle" name="street" value={street?.value} className={styles.half} onChange={(v: any) => setStreet({ ...street, value: v })} error={street?.error} />
                            <TextFieldShared label="Número" name="streetNumber" value={streetNumber?.value} className={styles.half} onChange={(v: any) => setStreetNumber({ ...streetNumber, value: v })} error={streetNumber?.error} checker="onlyNumbers" />
                        </div>
                    </div>

                    <div className={styles.editModalButtons}>
                        <ButtonShared onPress={() => setOpenEditModal(false)} title="Cancelar" tertiary />
                        <ButtonShared onPress={handleSave} title="Guardar cambios" primary loading={regions?.fetching === "loading" || loading} />
                    </div>

                    {!(user?.profile?.code === "seller") && (
                        <ButtonShared onPress={handleDelete} title="Eliminar cuenta" disabled={regions?.fetching === "loading" || loading} />
                    )}
                </div>
            </Modal>

            <Modal open={openDeleteModal} variant="white" className={styles.deleteModalContainer}>
                <p>¿Seguro que quieres ELIMINAR tu cuenta?</p>
                <div className={styles.deleteButtons}>
                    <ButtonShared onPress={() => setOpenDeleteModal(false)} title="Atras" tertiary />
                    <ButtonShared onPress={() => deleteUser(user?._id)} title="Eliminar" primary loading={loadingDeleteButton} />
                </div>
            </Modal>
        </>
    );
};

export default MyAccount;
